import {Component, OnInit} from "@angular/core";
import {IOption} from "ng-select";
import {BsModalRef} from "ngx-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import {HelperService} from "../services/helper.service";
import {RilrService} from "../services/rilr.service";
import { API_URL } from '../config';

@Component({
    selector: "app-report-print-preview",
    templateUrl: "./report-print-preview.component.html",
    styleUrls: ["./report-print-preview.component.scss"],
    providers: [RilrService, HelperService],
})
export class ReportPrintPreviewComponent implements OnInit {

    public masterData: any = {};
    public incidentColspan: number = 0;
    public reportSystemID: number;
    public documentSystemID: number;
    public documentTypeLabel: string = "incident report";
    public incidentTypeArr= [];
    public incidentTypeArrAll= [];
    public companySystemID = this.helperService.getSelectedCompanyId();
    public incidentCategoryArr: any[];
    public incidentSubCategoryArr: any[];
    public incidentSubCategoryDynamicArr: any[];
    public correctiveActionsTbl: any = [];
    public auditorsInformationTbl: any = [];

    constructor(public bsModalRef: BsModalRef,
                private helperService: HelperService,
                private spinner: NgxSpinnerService,
                private rilrService: RilrService) {
    }

    ngOnInit() {
        this.spinner.show();
        setTimeout(() => {
            this.reportPrintPreview();
        }, 0);

    }

    public reportPrintPreview() {
        const that = this;
        that.rilrService
            .reportPrintPreviewData()
            .get({
                companySystemID: that.companySystemID,
                reportSystemID: that.reportSystemID,
                documentSystemID: that.documentSystemID
            })
            .subscribe(data => {
                const resp = data.data.data;
                that.incidentTypeArr = that.helperService.incidentsIdChangeToInt(resp.incidents);
                that.incidentTypeArrAll = that.helperService.incidentsIdChangeToInt(resp.incidentsAll);
                that.incidentCategoryArr = resp.incidentCategory;
                that.incidentSubCategoryArr = resp.IncidentSubCategory;
                that.masterData = resp.reportData;
                that.incidentSubCategoryDynamicArr = resp.incidentDynamicSubCategory;
                that.correctiveActionsTbl = resp.actions;
                that.auditorsInformationTbl = resp.auditorDetails;
                that.documentTypeLabel = resp.document.documentDescription;

                  setTimeout(() => {
                    if(!that.incidentTypeArr.some((incident) => incident.id == that.masterData.reportNewSystemID)){
                        let incidentIndex = that.incidentTypeArrAll.findIndex(i => i.id == that.masterData.reportNewSystemID)
                        if(incidentIndex > -1){
                          that.incidentTypeArr.push(that.incidentTypeArrAll[incidentIndex])
                        }
                      }
                      that.incidentColspan = that.incidentTypeArr.length;
                }, 0);
           
                that.spinner.hide();
            }, (error) => {
                that.spinner.hide();
            });
    }

    public closeModal() {
        this.bsModalRef.hide();
    }

    public print_pdf_preview() {
        // const urlGeneratingPdf = 'api/v1/printReportPDF?id=' + this.reportSystemID + '&documentSystemID=' + this.documentSystemID + '&companySystemID=' + this.companySystemID;
        //  window.open(urlGeneratingPdf, '_blank');
        const that = this;
        that.rilrService
            .printReportPDF()
            .get({
                id: that.reportSystemID,
                documentSystemID: that.documentSystemID,
                companySystemID: that.companySystemID,
            })
            .subscribe(resp => {
                const data = resp.data.data;
                // window.open(data.pdf_path, "_blank");
                const link = document.createElement('a');
                link.target = '_blank';
                link.href = API_URL+'/'+data.pdf_path;
                link.setAttribute('visibility', 'hidden');
                link.click();
              
            }, (error) => {
                if (error.status == 500) {
                    //that.tosterMessageService.showError("Error", error.data.message);
                }
            });
    }
}



// WEBPACK FOOTER //
// /app/src/app/report-print-preview/report-print-preview.component.ts